var _path, _path2, _path3, _path4, _path5, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1251 4.0125C16.1251 4.695 15.8026 5.3025 15.3076 5.6925C14.9476 5.9775 14.4901 6.15 13.9876 6.15C12.8026 6.15 11.8501 5.1975 11.8501 4.0125C11.8501 3.51 12.0226 3.06 12.3076 2.6925H12.3151C12.6976 2.1975 13.3051 1.875 13.9876 1.875C15.1726 1.875 16.1251 2.8275 16.1251 4.0125Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15 4.0125C6.15 5.1975 5.1975 6.15 4.0125 6.15C3.51 6.15 3.06 5.9775 2.6925 5.6925C2.1975 5.3025 1.875 4.695 1.875 4.0125C1.875 2.8275 2.8275 1.875 4.0125 1.875C4.695 1.875 5.3025 2.1975 5.6925 2.6925C5.9775 3.06 6.15 3.51 6.15 4.0125Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1251 13.9875C16.1251 15.1725 15.1726 16.125 13.9876 16.125C13.3051 16.125 12.6976 15.8025 12.3151 15.3075H12.3076C12.0226 14.9475 11.8501 14.49 11.8501 13.9875C11.8501 12.8025 12.8026 11.85 13.9876 11.85C14.4901 11.85 14.9401 12.0225 15.3076 12.3075V12.315C15.8026 12.6975 16.1251 13.305 16.1251 13.9875Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15 13.9875C6.15 14.49 5.9775 14.94 5.6925 15.3075C5.3025 15.81 4.695 16.125 4.0125 16.125C2.8275 16.125 1.875 15.1725 1.875 13.9875C1.875 13.305 2.1975 12.6975 2.6925 12.315V12.3075C3.0525 12.0225 3.51 11.85 4.0125 11.85C5.1975 11.85 6.15 12.8025 6.15 13.9875Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 9C16.125 10.2 15.8325 11.3175 15.3075 12.3075C14.9475 12.0225 14.49 11.85 13.9875 11.85C12.8025 11.85 11.85 12.8025 11.85 13.9875C11.85 14.49 12.0225 14.94 12.3075 15.3075C11.3175 15.8325 10.2 16.125 9 16.125C7.8075 16.125 6.6825 15.8325 5.6925 15.3075C5.9775 14.9475 6.15 14.49 6.15 13.9875C6.15 12.8025 5.1975 11.85 4.0125 11.85C3.51 11.85 3.06 12.0225 2.6925 12.3075C2.1675 11.3175 1.875 10.2 1.875 9C1.875 7.8075 2.1675 6.6825 2.6925 5.6925C3.06 5.9775 3.51 6.15 4.0125 6.15C5.1975 6.15 6.15 5.1975 6.15 4.0125C6.15 3.51 5.9775 3.06 5.6925 2.6925C6.6825 2.1675 7.8075 1.875 9 1.875C10.2 1.875 11.3175 2.1675 12.3075 2.6925C12.0225 3.0525 11.85 3.51 11.85 4.0125C11.85 5.1975 12.8025 6.15 13.9875 6.15C14.49 6.15 14.94 5.9775 15.3075 5.6925C15.8325 6.6825 16.125 7.8075 16.125 9Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 2,
    height: 16,
    fill: "#E2E1E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 2,
    height: 16,
    transform: "rotate(-90 1 10)",
    fill: "#E2E1E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitTable);
export default __webpack_public_path__ + "static/media/splitTable.dcef7ffa1d789eecd7329f04c9af272a.svg";
export { ForwardRef as ReactComponent };